import { Editorcontrolitem } from "./editorcontrolitem.model";

export class ItemControlsPair {
    item:Editorcontrolitem;
    controls:Editorcontrolitem[];
    usedOnForm:boolean;


    constructor(item:Editorcontrolitem, controls:Editorcontrolitem[], usedOnForm:boolean){
        this.item = item;
        this.controls = controls;
        this.usedOnForm = usedOnForm;
    }
}
